import addresses from './src/addresses';

export const {
  countryDefinitions,
  countryName,
  stateName,
  validateFormInput,
  zipCodeFormat,
  zipCodeNormalize
} = addresses;

export const listAllCountriesOptionArray = (
  hasBlankRow,
  operatingCountries
) => {
  const countryCodes =
    operatingCountries || Object.keys(addresses.countryDefinitions);
  const optionArray = countryCodes.map((countryCode) => ({
    value: countryCode,
    option: addresses.countryName(countryCode)
  }));
  const sortedOptionArray = optionArray.sort((a, b) => {
    if (a.option > b.option) {
      return 1;
    }
    if (a.option < b.option) {
      return -1;
    }
    return 0;
  });
  if (hasBlankRow) {
    sortedOptionArray.unshift({ value: '', option: ' ' });
  }
  return sortedOptionArray;
};
